import addFit from 'widget/utils/helpers/addFit';
import MoreLink from 'widget/components/MoreLink';
import Row from 'widget/components/Row';
import Rows from 'widget/components/Rows';
import Text from 'widget/components/Text';
import TextHeading from 'widget/components/TextHeading';
import TrackImage from 'widget/components/TrackImage';
import useMount from 'hooks/useMount';
import { Track } from 'state/Tracks/types';
import { useState } from 'react';
import { useTranslate } from 'widget/hooks';

type Props = {
  cursorPointer?: boolean;
  tracks: Array<Track>;
  playlistRadioUrl?: string;
};

function Tracks({ cursorPointer = true, tracks, playlistRadioUrl }: Props) {
  const translate = useTranslate();

  const [windowRef, setWindowRef] = useState({} as Window);

  useMount(() => setWindowRef(window));

  return (
    <Rows height={windowRef?.innerHeight ?? 0}>
      <Row cursorPointer={cursorPointer} thinRow>
        <Text>{translate('Featured artists in this playlist')}</Text>
      </Row>
      {tracks.map(({ artistName, artistId, id }) => {
        const imageUrl = `https://i.iheart.com/v3/catalog/artist/${artistId}?ops=fit(60%2C60)`;
        return (
          <Row cursorPointer={cursorPointer} key={id} thinRow>
            {imageUrl && <TrackImage src={addFit(imageUrl)} />}
            <TextHeading>{artistName}</TextHeading>
          </Row>
        );
      })}
      <MoreLink
        href={playlistRadioUrl || ''}
        text={translate('View Playlist')}
      />
    </Rows>
  );
}

export default Tracks;
